/**
 Copyright Highway9 Networks Inc.
 */

import { DataObject } from "./dataObject";
import { ImageInfo } from "./ImageInfo";
export interface UserInfo extends DataObject {
  authType: string[];
  cpiDetails?: CpiDetails;
  readonly creationTime?: number;
  readonly email: string;
  generatePassword?: boolean;
  profilePicture?: ImageInfo;
  readonly id?: string;
  readonly isActive: boolean;
  name: string;
  readonly passwordExpiryTime?: number;
  readonly passwordHistory?: any[]
  readonly roles: string[];
  // MCS-3799: original CSP role for partner users whose effective `roles` was rewritten to RAN_KPI_ONLY.
  readonly displayRole?: string[];
  timezone: string;
  runtimeInfo?: any;
  sendWelcomeEmail: boolean;
  status?: string;
  plmnList?: string[];
  updationTime: number;


  resetPassword?: ResetPassword
  passwordExpiryMailTime?: number
  inActiveReason?: string
  passwordAttempt?: number
  countryCode?: string
  phoneNumber?: string
}

interface Keyfile {
  content?: any;
  name: string;
}

export interface CpiDetails {
  id: string;
  keyfile: Keyfile;
  name: string;
  password: string;
  savePolicy: string;
}

export type UserPermission = "VIEW" | "ADD" | "EDIT" | "DELETE" | "LOGIN" | "LOGOUT" | "OPERATION" | "UPDATE_PROFILE";
export enum PermissionObject {
  controller = "controller",
  configuration = "configuration",
  edge = "edge",
  edgePool = "edgePool",
  radio = "radio",
  user = "user",
  order = "order",
  login = "login",
  log = "log",
  metric = "metric",
  network = "network",
  note = "note",
  dnn = "dnn",
  application = "application",
  device = "device",
  deviceGroup = "deviceGroup",
  diagnosticsRan = "diagnosticsRan",
  diagnosticsUe = "diagnosticsUe",
  qosProfile = "qosProfile",
  qci = "qci",
  zone = "zone",
  zoneGroup = "zoneGroup",
  monitoringSystem = "monitoringSystem",
  supportChannel = "supportChannel",
  aaaServerProfile = "aaaServerProfile",
  systemSettings = "systemSettings",
  alarm = "alarm",
  operation = "operation",
  accessConfig = "accessConfig",
  radioSite = "radioSite",
  coverageZone = "coverageZone",
  radioGroup = "radioGroup",
  mobilityProfile = "mobilityProfile",
  mnoOperator = "mnoOperator",
  mnoCoreConfig = "mnoCoreConfig",
  mnoSecurityGatewayConfig = "mnoSecurityGatewayConfig",
  mnoCmpConfig = "mnoCmpConfig",
  mnoOperatorRadio = "mnoOperatorRadio",
  siGrpcClientContext = "siGrpcClientContext",
  auditLog = "auditLog",
  controlPlaneInfo = "controlPlaneInfo",
  location = "location",
  serviceController = "serviceController",
  simOrder = "simOrder",
  tenant = "tenant",
  partner = "partner",
  edgeRelease = "edgeRelease",
  radioRelease = "radioRelease",
  grpcPushEntry = "grpcPushEntry",
  eciPool = "eciPool",
  vmcHardware = "vmcHardware",
  mnoConnectedDevices = "mnoConnectedDevices",
  mnoConnectedRadios = "mnoConnectedRadios",
  hardware = "hardware",
  shellCommand = "shellCommand",
  ipsecParams = "ipsecParams",
  secret = "secret",
  certificate = "certificate",
  simulator = "simulator",
  apiToken = "apiToken",
  clockPool = "clockPool",
  password = "password",
  partnerRadioManager = "partnerRadioManager",
  vmcPartnerRadioManager = "vmcPartnerRadioManager",
  edgepool = "edgepool",
  cloudTunnelHealth = "cloudTunnelHealth",
  radioGlobalConfig = "radioGlobalConfig",
  metricsTemplate = "metricsTemplate",
  image = "image",
  deviceInfo = "deviceInfo",
  publicImage = "publicImage",
  product = "product",
  mnoConnectedCores = "mnoConnectedCores",
  dashboardKpiSummary = "dashboardKpiSummary",
  itAdminDashboard = "itAdminDashboard",
  dailyReport = "dailyReport",
  insights = "insights",
  summaryStatus = "summaryStatus",
  certificatePool = "certificatePool",
  alertProfile = "alertProfile",
  ciqExport = "ciqExport",
  siteImport = "siteImport",
  supportTunnel = "supportTunnel",
}

export interface Permission {
  objectType: PermissionObject;
  permissions: UserPermission[];
}

export interface ResetPassword {
  otp: string
  otpExpiredAt: number
}

export interface UserSessionInfo {
  success: boolean
  token: string
  isOperator: boolean
  serviceInstanceName?: string
  email: string
  userName: string
  displayName?: string
  userId: string
}